import { render, staticRenderFns } from "./SurfTestView.vue?vue&type=template&id=eadef4f0&scoped=true&"
import script from "./SurfTestView.vue?vue&type=script&lang=js&"
export * from "./SurfTestView.vue?vue&type=script&lang=js&"
import style0 from "./SurfTestView.vue?vue&type=style&index=0&id=eadef4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadef4f0",
  null
  
)

export default component.exports